export default __webpack_public_path__ + "static/media/arrow.3b2ae849.svg";